import { Badge } from '@/components/ui/badge'
import { Crown, MapPin, List, Briefcase, Users } from 'lucide-react'
import type { CandidateRole } from '@/types'
import { cn } from '@/lib/utils'

interface CandidateRoleBadgeProps {
  role: CandidateRole
  districtName?: string
  className?: string
}

const ROLE_CONFIG: Record<
  CandidateRole,
  {
    label: string
    variant: 'default' | 'secondary' | 'outline' | 'destructive'
    bgColor: string
    icon: typeof Crown
  }
> = {
  none: {
    label: 'Unassigned',
    variant: 'outline',
    bgColor: '',
    icon: Users,
  },
  party_leader: {
    label: 'Party Leader',
    variant: 'default',
    bgColor: 'bg-amber-500 hover:bg-amber-500/80 text-amber-950',
    icon: Crown,
  },
  regional_candidate: {
    label: 'Regional',
    variant: 'default',
    bgColor: 'bg-blue-500 hover:bg-blue-500/80 text-white',
    icon: MapPin,
  },
  list_candidate: {
    label: 'List Candidate',
    variant: 'default',
    bgColor: 'bg-purple-500 hover:bg-purple-500/80 text-white',
    icon: List,
  },
  minister: {
    label: 'Minister',
    variant: 'default',
    bgColor: 'bg-green-500 hover:bg-green-500/80 text-white',
    icon: Briefcase,
  },
  chair: {
    label: 'Chair',
    variant: 'default',
    bgColor: 'bg-teal-500 hover:bg-teal-500/80 text-white',
    icon: Users,
  },
}

export function CandidateRoleBadge({
  role,
  districtName,
  className,
}: CandidateRoleBadgeProps) {
  const config = ROLE_CONFIG[role]
  const Icon = config.icon

  const label =
    role === 'regional_candidate' && districtName
      ? `Regional - ${districtName}`
      : config.label

  return (
    <Badge
      variant={config.variant}
      className={cn('gap-1 text-xs', config.bgColor, className)}
    >
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  )
}
